export const Columns = [
  {
    Header: "ID",
    accessor: "documentID",
  },
  {
    Header: "Case ID",
    accessor: "case_number",
  },
  {
    Header: "File",
    accessor: "extension",
  },
  {
    Header: "Name",
    accessor: "title",
  },
  {
    Header: "Category",
    accessor: "badge",
  },
  {
    Header: "Category Color",
    accessor: "bg_color",
  },

  {
    Header: "Uploaded",
    accessor: "date_entered",
  },
];
